module.exports = __webpack_public_path__ + "static/media/annotation-layers-inverted.2cdda8f4.svg";